import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Loader from './Loader';
import store from './Store';

import './Weather.css';

function format_date( strdate ) {
    const [year, month, day] = strdate.split('-');
    const date = new Date(strdate);
    const dayOfWeek =  date ? ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][date.getDay()] : 'Unknown';
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month-1];
    return `${dayOfWeek}, ${monthName} ${day} ${year}`;
}

// temperature scales
const T = {
    fahrenheit: {symbol: '\u2109', celsius: t => ((5/9) * (t - 32)) },
    celsius: {symbol: '\u2103', fahrenheit: t => (t * 9 / 5 + 32) }
}

function format_num( n, p ) {
    return Math.round(+n); //(+n).toFixed(+(p || 2));
}

function format_temp( t, scale, convert, withsymbol ) {
    scale = scale || 'celsius';
    if ( convert ) t = T['fahrenheit' === scale ? 'celsius' : 'fahrenheit'][scale](t);
    return format_num( t ) + (withsymbol ? T[scale].symbol : '');
}

function weather_icon( icon, type ) {
    return "https://www.metaweather.com/static/img/weather/"+icon+"."+(type||"svg").toLowerCase();
}

function wind_icon( dir ) {
    return (<i className={"wind-dir "+dir.toLowerCase()}></i>);
}

const API_URL = 'https://api.allorigins.win/get?url=' + encodeURIComponent('https://www.metaweather.com/api/location/');
//const API_URL = 'http://localhost:8080/weather.php?command=location&woeid=';
//const API_URL = '/weather.php?command=location&woeid=';


function WeatherData( data, detailed ) {
    if ( data && data.consolidated_weather && data.consolidated_weather.length ) {
        if ( detailed ) {
            return data.consolidated_weather.map(current => (
                <div className="weather-data">
                <p><b>{format_date( current.applicable_date )}</b></p>
                <img className="weather-icon" src={weather_icon(current.weather_state_abbr)} alt={current.weather_state_name} title={current.weather_state_name} />
                <p><span className="weather-details">{format_temp(current.the_temp, 'celsius', 0, 1)} ({format_temp(current.min_temp, 'celsius', 0, 1)} &mdash; {format_temp(current.max_temp, 'celsius', 0, 1)})</span></p>
                <p><span className="weather-details">{format_num(current.wind_speed)}mph</span> {wind_icon(current.wind_direction_compass)} ({current.wind_direction_compass})</p>
                </div>
            ));
        } else {
            let current = data.consolidated_weather[0];
            return (
                <div className="weather-data">
                <p><b>Today</b></p>
                <img className="weather-icon" src={weather_icon(current.weather_state_abbr)} alt={current.weather_state_name} title={current.weather_state_name} />
                <p><span className="weather-details">{format_temp(current.the_temp, 'celsius', 0, 1)} ({format_temp(current.min_temp, 'celsius', 0, 1)} &mdash; {format_temp(current.max_temp, 'celsius', 0, 1)})</span></p>
                <p><span className="weather-details">{format_num(current.wind_speed)}mph</span> {wind_icon(current.wind_direction_compass)} ({current.wind_direction_compass})</p>
                </div>
            );
        }
    } else {
        return (
            <div className="weather-data">
            <p><b>No data!</b></p>
            </div>
        );
    }
}

class Weather extends Component {
    constructor(props) {
        super(props);
        this.state = {
            city: this.props.city ? this.props.city : '..',
            loading: true,
            data: null
        };
    }

    componentDidMount() {
        if ( !this.props.woeid ) return;

        let weatherData = store.get('weather_'+this.props.woeid);
        if ( weatherData ) {
            this.setState({
                city: weatherData.title,
                loading: false,
                data: weatherData
            });
        } else {
            fetch(API_URL+this.props.woeid)
            .then(response => response.json())
            .then(jsonResponse => {
                if (jsonResponse.contents) jsonResponse = JSON.parse(jsonResponse.contents);
                store.set('weather_'+this.props.woeid, jsonResponse);
                this.setState({
                    city: jsonResponse.title,
                    loading: false,
                    data: jsonResponse
                });
            });
        }
    }

    render() {
        return (
            <div className={"weather" + (this.props.detailed ? " detailed" : "")}>
                <div className="weather-header">
                {this.props.detailed ? (<b>{this.state.city + ' (Forecast)'}</b>) : (<Link to={"/weather/"+this.props.woeid}><b>{this.state.city}</b></Link>)}
                </div>
                <div className="weather-content">
                    {this.state.loading ? (<Loader text="Loading.."/>) : WeatherData(this.state.data, this.props.detailed)}
                </div>
            </div>
        );
    }
}

export default Weather;
